/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { TrainRequestBuilderRequestsMetadata, type TrainRequestBuilder } from './train/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/forecasting/models/order-volume
 */
export interface OrderVolumeRequestBuilder extends BaseRequestBuilder<OrderVolumeRequestBuilder> {
    /**
     * The train property
     */
    get train(): TrainRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const OrderVolumeRequestBuilderUriTemplate = "{+baseurl}/api/forecasting/models/order-volume";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const OrderVolumeRequestBuilderNavigationMetadata: Record<Exclude<keyof OrderVolumeRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    train: {
        requestsMetadata: TrainRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
